import React from 'react';
import PropTypes from "prop-types";
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import sectionCSS from './SectionOuterContainer.scss';
import Footer from '../common/Footer';

const IntakeFooter = props => {

  const getSubmitButton = () => {
    return (
      <StyledButton
        aria-label="Save & Submit"
        type="submit"
        className={sectionCSS['save-next-button']}
        aria-disabled={!props.canSubmit}
        onClick={() => props.canSubmit && props.onSubmitButtonClick()}
      >
        <>
          <span>{props.saveText}</span>
          <Icon icon='keyboard_arrow_right' aria-hidden='true' />
        </>
      </StyledButton>
    );
  };

  const getCancelButton = () => {
    if ( !props.showCancelButton ) return null;
    return (
      <StyledButton 
        aria-label="Cancel"
        className={sectionCSS['signin-button']} 
        aria-disabled={false} 
        asLink={true}
        onClick={props.onCancelButtonClick}
      >
        Cancel
      </StyledButton>
    )
  };

  return (
    <Footer
      className={sectionCSS['intake-questions-footer']}
      primaryButton={getSubmitButton()}
      secondaryButton={getCancelButton()}
    />
  );
};

IntakeFooter.propTypes = {
  showCancelButton: PropTypes.bool.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  saveText: PropTypes.string.isRequired,
  onCancelButtonClick: PropTypes.func.isRequired,
  onSubmitButtonClick: PropTypes.func.isRequired,
};

export default IntakeFooter;
